import React from "react";
import PropTypes from "prop-types";

const Row = ({ children, isHeader, rest }) => {
  return (
    <div
      className={`customTable__table-row ${
        isHeader ? "customTable__table-header" : "tableRowHover"
      }`}
      // key={key}
      {...rest}
    >
      {children}
    </div>
  );
};

Row.defaultProps = {
  children: null,
  isHeader: false,
  // key: 0,
};

Row.propTypes = {
  children: PropTypes.any,
  isHeader: PropTypes.bool,
  // key: PropTypes.number,
};

export default Row;
